export default "__VITE_ASSET__CGthlgYE__"